<template>
  <div class="activity-turntable">
    <img class="img" :src="truntable.activityBackgroundAfter" alt="">
    <section class="warp">
      <img :src="truntable.couponPicture" alt="">
      <!-- <div v-if="truntable.isPrint === 'true'" class="reprintBtn" :style="{background:'url('+truntable.reprintBtn+') no-repeat'}">分享领券8.88元无门槛红包</div>
      <div v-else class="reprintBtn" :style="{background:'url('+truntable.receiveBtn+') no-repeat'}">立即领取</div> -->
      <section class="telephone">
        <ul>
          <li>
            <section class="phone">
              <input type="number" v-model="phone" placeholder="请输入电话号码">
            </section>
          </li>
          <li class="code">
            <dl>
              <dt>
                <section>
                  <input type="text" v-model="code" placeholder="请输入验证码">
                </section>
              </dt>
              <dd>
                <button class="code_button" @click="getVerificationCode">
                    <span>获取验证码</span>
                </button>
              </dd>
            </dl>
          </li>
          <li  class="button">
            <section :style="styleButton" @click="handleReceive">
              立即领取
            </section>
          </li>
        </ul>
      </section>
    </section>
  </div>
</template>
<script>
export default {
  name: "activity-turntable",
  data() {
    return {
      activityId: this.$route.query.activityId,
      aid: this.$route.query.aid,
      truntable: "",
      styleButton: {},
      phone: "",
      code: ""
    };
  },
  created() {
    this.getActivity();
  },
  methods: {
    getActivity() {
      this.service.getCouponActivityDetail(this.activityId).then(res => {
        console.log(res);
        if (res.success) {
          this.truntable = res.data;
          this.styleButton.background =
            "url(" + this.truntable.reprintBtn + ") no-repeat";
          this.styleButton.backgroundSize = "contain";
          this.styleButton.color = this.truntable.fontColor;
        }
      });
    },
    getVerificationCode() {
      if (!this.tools.isTelephone(this.phone)) {
        this.alert("提示", "手机格式不正确");
        return false;
      }
      let codePhone = {
        telephone: this.phone
      };
      this.service.verificationCode(codePhone).then(res => {
        console.log(res);
        if (res.success) {
          this.alert("提示", "发送成功");
          let code = document.querySelector(".code_button");
          this.tools.settime(code, 60, true);
        } else {
          this.alert("提示", "发送失败");
        }
      });
    },
    handleReceive() {
      if (this.phone === "") {
        this.alert("提示", "请输入手机号");
        return false;
      }
      let codePhone = {
        telephone: this.phone,
        code: this.code,
        activityId: this.activityId
      };
      this.service.verificationCodeCheckCode(codePhone).then(res => {
        console.log(res);
        if (res.success) {
          this.alert("提示", res.message).then(action => {
            console.log("ssss");
            this.$router.push(
              `/activity/turntable/after/Receive?activityId=` + this.activityId
            );
          });
        } else {
          this.alert("提示", res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.activity-turntable {
  width: 100vw;
  // height: 100vh;
  // overflow: hidden;

  .img {
    width: 100%;
    // height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
  }
  .warp {
    width: 100vw;
    height: 100vh;
    position: relative;
    z-index: 999;
    text-align: center;
    img {
      width: 9rem;
      height: 3.3rem;
      overflow: hidden;
      margin: 58.5vh auto 0 auto;
    }
    .reprintBtn {
      background-size: contain !important;
      border-radius: 0.6rem;
    }
    // div {
    //   font-size: 0.4rem;
    //   text-align: center;
    //   height: 1.1rem;
    //   width: 7rem;
    //   color: red;
    //   margin: 12vh auto;
    //   line-height: 1.1rem;
    // }
    .telephone {
      width: 7rem;
      margin: 1.2rem auto;
      li {
        list-style: none;
      }
      input {
        background-color: rgba(0, 0, 0, 0);
        border: none;
        outline: none;
      }
      .phone {
        background: url("../assets/images/activity/phone.png") no-repeat;
        background-size: contain;
        height: 1.2rem;
        margin: 1rem auto 0.3rem auto;
        input {
          height: 1.2rem;
          width: 4.5rem;
        }
      }
      .code {
        dl {
          width: 100%;
          // display: -webkit-box;
          // display: -moz-box;
          // display: -webkit-flex;
          // display: flex;
          // justify-content: space-between;
          // -webkit-justify-content: space-between;

          dt {
            display: inline-block;
            // margin-left: -0.2rem;
            section {
              width: 4rem;
              height: 1.6rem;
              background: url("../assets/images/activity/pwd.png") no-repeat;
              background-size: contain;
              input {
                height: 1.15rem;
                width: 3rem;
                padding-left: 0.7rem;
              }
            }
          }
          dd {
            display: inline-block;
            margin-left: 0.2rem;

            button {
              border: none;
              width: 2.7rem;
              height: 1.16rem;
              border-radius: 0.58rem;
              background-color: #fff;
              // background: url("../assets/images/activity/code.png") no-repeat;
              // background-size: contain;
              span {
                font-size: 0.32rem;
                color: rgb(117, 117, 117);
                line-height: 1.15rem;
              }
            }
            button:disabled {
              background-color: #ccc;
            }
          }
        }
      }
      .button {
        section {
          line-height: 1.1rem;
          font-size: 0.4rem;
          height: 1.4rem;
          letter-spacing: 0.1rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// activityTurntableAfter.vue?e55c73c8